import React from 'react'
import BrandLayout from '../components/Layouts/BrandLayout'
import ProtectByAccessToken from '../components/Security/ProtectByAccessToken'
import FooterSectionContainer from '../containers/FooterSection/FooterSection.container'
import HeaderSectionContainer from '../containers/HeaderSection/HeaderSection.container'
import HomeContainer from '../containers/Home/Home.container'
import NotFound from './NotFound'

/**
 * The Home's page.
 */
const Home = () => {
  return (
    <ProtectByAccessToken fallback={() => <NotFound />}>
      <BrandLayout footer={<FooterSectionContainer />} header={<HeaderSectionContainer />}>
        <HomeContainer />
      </BrandLayout>
    </ProtectByAccessToken>
  )
}

export default Home
